module.exports = __webpack_public_path__ + "static/media/8604-l.f7c18a3f.png";